import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ApiService } from '../../services/api'
import { Category } from '../../types/category'

// Async thunk
export const fetchCategories = createAsyncThunk(
  'categories/fetchCategories',
  async (params: { limit?: number; offset?: number } = {}) => {
    const categories = await ApiService.getCategories(params)
    return categories
  },
)

// Types
interface CategoriesState {
  categories: Category[]
  loading: boolean
  error: string | null
  lastFetch: number | null
}

const initialState: CategoriesState = {
  categories: [],
  loading: true,
  error: null,
  lastFetch: null,
}

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    // Clear error
    clearError: state => {
      state.error = null
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchCategories.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false
        state.categories = action.payload
        state.lastFetch = Date.now()
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to fetch categories'
      })
  },
})

export const { clearError } = categoriesSlice.actions

export default categoriesSlice.reducer
